// @flow
import Loadable from '@src/components/Loadable';

const LoginLoader = Loadable({
  loader: () => import('./LoginContainer'),
});

export default LoginLoader;
